// src/processors/style/index.ts - Style Module Exports
import {ProcessResult} from "../../types";

export { StyleProcessor } from './style-processor';
export { StyleContentProcessor } from './style-content-processor';
export { StyleFileHandler } from './style-file-handler';
export { StyleUrlMatcher } from './style-url-matcher';

// Convenience function for backward compatibility
import {  XConVitePluginOptions } from '../../types';
import { StyleProcessor } from './style-processor';
import {Logger} from "../../utils/logger";

/**
 * Process styleUrls -> styles array conversion (backward compatibility function)
 */
export function processStyleUrls(
    code: string,
    id: string,
    options: Required<XConVitePluginOptions>,
    addWatchFile: (file: string) => void,
    logger: Logger,
    terser?: any
): ProcessResult {
    const processor = new StyleProcessor(options, logger, terser);
    return processor.processStyleUrls(code, id, addWatchFile);
}